import { render } from "./BasicFormModal.vue?vue&type=template&id=55979d86&scoped=true"
import script from "./BasicFormModal.vue?vue&type=script&lang=js"
export * from "./BasicFormModal.vue?vue&type=script&lang=js"

import "./BasicFormModal.vue?vue&type=style&index=0&id=55979d86&lang=scss&scoped=true"

import exportComponent from "/Users/mateuszsalamonski/WebstormProjects/ems_web/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55979d86"]])

export default __exports__